// extracted by css-extract-rspack-plugin
export default {"noRateText":"rgIe7H5Q6rvH2l4mgnrtL"};